module.exports = "<fes-status [color]=\"color\" [tag]=\"tag\"></fes-status>\n"